import { useLeadFunnel } from "@/contexts/LeadFunnelContext";

export const MobileCallBar = () => {
  const { open } = useLeadFunnel();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-brass/30 bg-charcoal/95 backdrop-blur supports-[backdrop-filter]:bg-charcoal/85 shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.5)]">
      <button
        onClick={open}
        className="w-full flex items-center justify-center gap-2 py-4 bg-gradient-brass text-warm-white font-bold tracking-wide uppercase text-sm"
      >
        Get My Estimate
      </button>
    </div>
  );
};
